export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_DEFAULT_complete_2.c8426e96.jpg";